<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM板材颜色工厂用量榜 right_5"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')}`"
      :tooltipText="'板材领料实时数量'"
      ><el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-left: 10px"
        @click="handleDetail"
        >详 情</el-button
      ></chart-title
    >
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="right_5" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import { getFactoryColor } from "@/api/cockpit/jyl";
import {
  formatTime,
  getNextMonth,
  getLastDate,
  getFirstDate,
  arrDataFormat,
} from "@/utils/index";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "right_5",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      chartData: [],
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    getData() {
      const data = {
        batch_time: [
          getFirstDate(this.date, "yyyy-MM-dd"),
          getLastDate(this.date, "yyyy-MM-dd"),
        ],
      };
      getFactoryColor(data).then((resp) => {
        this.chartData = arrDataFormat(resp.data.list);
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_5"));
      this.setOptions();
    },
    setOptions() {
      const color = ["59,157,255", "34,228,255", "59,255,208", "4,227,138"];
      let seriesData = this.chartData.map((m) => {
        return {
          value: m.value,
        };
      });
      seriesData = seriesData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: `rgba(${color[i % 4]},1)`,
              },
              {
                offset: 1,
                color: `rgba(${color[i % 4]},0.1)`,
              },
            ]),
          },
        };
      });
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          right: "16%",
          left: "13%",
          top: "6%",
          bottom: "4%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          data: this.chartData.map((m) => m.name),
        },
        series: [
          {
            name: "用量",
            type: "bar",
            barWidth: 5,
            data: seriesData,
            itemStyle: {
              borderRadius: 5,
            },
            color: "#009dff",
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
    handleDetail() {
      //跳转erp板材统计
      window.open(
        `${process.env.VUE_APP_JYL_URL}/#/login?nameJSC=statistics.shipment&username=${process.env.VUE_APP_NAME_MES}&password=${process.env.VUE_APP_PASS}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 60vh;
  #right_5 {
    height: 100%;
  }
}
</style>
